export const PRODUCT_RATE_PLAN_SYMBOLS = {
    MIN_SMS_GB: 'MIN / SMS / GB',
    MIN_SMS: 'MIN / SMS',
    MIN: 'MIN',
    SMS: 'SMS',
};

export const POLL_ORDER_RETRY_COUNT = 30;
export const POLL_ORDER_RETRY_DELAY = 1000;

export const POLL_CONFIRMATION_ORDER_RETRY_COUNT = 30;
export const POLL_CONFIRMATION_ORDER_RETRY_DELAY = 1000;

export const VARIANT_QUERY_PARAM = 'variant';
export const CONTRACT_TYPE_QUERY_PARAM = 'contract-type';

export const baseProductFilteringParams = {
    fields: 'code,variantMatrix(FULL),shortDescription,shortDescription2,shortDescription3,badges,productType,marketingTag(FULL),brand,name,categoryUrl,url',
};
